import { Component } from '@angular/core';

@Component({
    selector: 'app-administration',
    templateUrl: './administration.component.html',
    styleUrl: './administration.component.css',
    standalone: false
})
export class AdministrationComponent {

}
